// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"127":"1e587a42","315":"31d17f90","624":"ca7ae43e"}[chunkId] + ".js";
};